import { css } from "@linaria/core";

import { easingProps } from "../../../../styles/variables";

const propPrefix = "--underline-active-element";

export const underlineOffsetProp = `${propPrefix}--offset`;
export const underlineSizeProp = `${propPrefix}--size`;
export const underlineColorProp = `${propPrefix}--color`;
export const underlineTransitionDurationMs = 175;

export const wrapperCls = css`
  ${underlineOffsetProp}: 0;
  ${underlineSizeProp}: 0;
  ${underlineColorProp}: currentColor;

  position: relative;

  &::after {
    content: "";
    position: absolute;
    background-color: var(${underlineColorProp});
    pointer-events: none;
    opacity: 0;
  }
`;

export const horizontalCls = css`
  &::after {
    left: 0;
    bottom: 0;

    height: 3px;
    width: var(${underlineSizeProp});

    transform: translateX(var(${underlineOffsetProp}));
  }
`;

export const verticalCls = css`
  &::after {
    top: 0;
    left: 0;

    height: var(${underlineSizeProp});
    width: 3px;

    transform: translateY(var(${underlineOffsetProp}));
  }
`;

export const readyCls = css`
  &::after {
    /**
     * don'y apply any transitions until the "ready" class has been added to the
     * container; this prevents a transition from happening on the initial
     * mount, where we instead rely on initial enter transition of the entire
     * layout
     */
    transition:
      opacity ${underlineTransitionDurationMs}ms linear,
      width ${underlineTransitionDurationMs}ms var(${easingProps.inOutQuad}),
      height ${underlineTransitionDurationMs}ms var(${easingProps.inOutQuad});
  }
`;

export const visibleCls = css`
  &::after {
    opacity: 1;

    /**
     * apply transition on the offset only when the underline was already
     * visible
     *
     * this way, if the underline had disappeared, then it will simply appear
     * to be drawn under the active item once re-enabled; not scale in all the
     * way from the left side
     */
    transition:
      opacity ${underlineTransitionDurationMs}ms linear,
      width ${underlineTransitionDurationMs}ms var(${easingProps.inOutQuad}),
      height ${underlineTransitionDurationMs}ms var(${easingProps.inOutQuad}),
      transform ${underlineTransitionDurationMs}ms var(${easingProps.inOutQuad})
        15ms;
  }
`;
